<template>
  <v-card rounded="lg" elevation="1" class="pa-5 mt-6">
    <template v-if="!submitted">
      <div class="text-overline text-medium-emphasis mb-3">Feedback</div>
      <p class="text-body-2 mb-4">Cât de bine te descrie acest profil?</p>

      <div class="d-flex gap-2 mb-4">
        <v-btn
          v-for="n in 5"
          :key="n"
          :variant="selectedRating === n ? 'flat' : 'tonal'"
          :color="selectedRating === n ? 'primary' : 'default'"
          size="small"
          icon
          :disabled="saving"
          @click="selectedRating = n"
        >
          {{ EMOJI[n] }}
        </v-btn>
      </div>

      <v-expand-transition>
        <v-textarea
          v-if="selectedRating !== null && selectedRating <= 2"
          v-model="comment"
          label="Ce nu se potrivește?"
          rows="2"
          auto-grow
          variant="outlined"
          density="compact"
          class="mb-3"
          :disabled="saving"
        />
      </v-expand-transition>

      <v-btn
        color="primary"
        variant="tonal"
        size="small"
        :disabled="selectedRating === null"
        :loading="saving"
        @click="submit"
      >
        Trimite
      </v-btn>
    </template>

    <template v-else>
      <p class="text-body-2 text-medium-emphasis">Mulțumim pentru feedback!</p>
    </template>
  </v-card>
</template>

<script>
import apiService from '@/services/ApiService'

const EMOJI = Object.freeze({ 1: '😞', 2: '😕', 3: '😐', 4: '🙂', 5: '😊' })

export default {
  name: 'ProfileFeedbackCard',

  emits: ['rateSubmitted'],

  data() {
    return {
      EMOJI,
      selectedRating: null,
      comment: '',
      saving: false,
      submitted: false,
    }
  },

  methods: {

    /**
     * Sends the rating (and optional comment) to the backend.
     * @returns {Promise<void>}
     */
    async submit() {
      if (!this.selectedRating) return
      this.saving = true
      try {
        await apiService.saveProfileRating(this.selectedRating, this.comment)
        this.submitted = true
        this.$emit('rateSubmitted', this.selectedRating)
      } catch (err) {
        console.error('ProfileFeedbackCard > submit error:', err)
      } finally {
        this.saving = false
      }
    },
  },
}
</script>
